var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7323 8.53152L9.35227 0.141523C9.16227 -0.0484766 8.85227 -0.0484766 8.66227 0.141523L0.272273 8.53152C-0.0377273 8.84152 0.182273 9.37152 0.622273 9.37152H2.01227C2.14227 9.37152 2.26227 9.32152 2.36227 9.23152L8.02227 3.55152V19.5115C8.02227 19.7815 8.24227 20.0015 8.51227 20.0015H9.49227C9.76227 20.0015 9.98227 19.7815 9.98227 19.5115V3.55152L15.6523 9.22152C15.7423 9.31152 15.8723 9.36152 16.0023 9.36152H17.3823C17.8223 9.36152 18.0323 8.83152 17.7323 8.52152V8.53152Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/IconArrowUp.825123e711de9cc57f3c57db1e05e434.svg";
export { ForwardRef as ReactComponent };